import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BellRing, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Panel } from "@/components/PageHeader";
import { api, errMsg } from "@/lib/api";

export function AlertSettings({ cfg, saveCfg }) {
  const [a, setA] = useState(cfg.alert);
  const [rec, setRec] = useState((cfg.alert.recipients || []).join(", "));
  const [busy, setBusy] = useState("");
  useEffect(() => { setA(cfg.alert); setRec((cfg.alert.recipients || []).join(", ")); }, [cfg.alert]);

  const save = async () => {
    setBusy("save");
    try { await saveCfg({ ...cfg, alert: { ...a, recipients: rec.split(",").map((x) => x.trim()).filter(Boolean) } }); toast.success("Avviso salvato"); } catch (e) { /* toast già mostrato */ } finally { setBusy(""); }
  };
  const sendNow = async () => {
    setBusy("send");
    try {
      const r = await api.post("/cards/alert/send");
      if (r.data.error) toast.error(r.data.error);
      else if (!r.data.new) toast.info("Nessuna nuova carta sospetta da segnalare (già inviate di recente)");
      else toast.success(`Inviata a ${r.data.recipients.join(", ")}: ${r.data.new} carte`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); }
  };

  return (
    <Panel title={<span className="flex items-center gap-2"><BellRing className="h-4 w-4 text-slate-400" />Avviso email giornaliero (ore 8:30)</span>} testId="alert-settings">
      <div className="grid gap-3 p-4 lg:grid-cols-[auto_1fr_auto_auto] lg:items-end">
        <label className="flex items-center gap-2 text-sm text-slate-700"><Switch data-testid="alert-enabled-switch" checked={!!a.enabled} onCheckedChange={(v) => setA({ ...a, enabled: v })} />Attivo</label>
        <div className="space-y-1"><Label className="text-xs text-slate-500">Destinatari (email separate da virgola; vuoto = amministratori)</Label><Input data-testid="alert-recipients-input" value={rec} onChange={(e) => setRec(e.target.value)} placeholder="operatore@azienda.it, sicurezza@azienda.it" /></div>
        <div className="space-y-1"><Label className="text-xs text-slate-500">Rinotifica dopo (giorni)</Label><Input type="number" min="1" className="w-24 font-mono text-sm" data-testid="alert-renotify-input" value={a.renotify_days} onChange={(e) => setA({ ...a, renotify_days: Number(e.target.value) })} /></div>
        <div className="flex gap-2">
          <Button size="sm" data-testid="alert-save" disabled={!!busy} onClick={save}>{busy === "save" ? "Salvo..." : "Salva"}</Button>
          <Button size="sm" variant="outline" data-testid="alert-send-now" disabled={!!busy} onClick={sendNow}><Send className="mr-1.5 h-3.5 w-3.5" />{busy === "send" ? "Invio..." : "Invia ora"}</Button>
        </div>
        <label className="flex items-center gap-2 text-sm text-slate-700 lg:col-span-1"><Switch data-testid="alert-link-switch" checked={a.include_link !== false} onCheckedChange={(v) => setA({ ...a, include_link: v })} />Pulsante "Verifica nel pannello"</label>
        <div className="space-y-1 lg:col-span-3"><Label className="text-xs text-slate-500">Link del pulsante (vuoto = pagina KPI Carte di questo circuito, con accesso)</Label><Input data-testid="alert-link-input" disabled={a.include_link === false} value={a.link_url || ""} onChange={(e) => setA({ ...a, link_url: e.target.value })} placeholder="https://..." /></div>
      </div>
    </Panel>
  );
}
